import { Injectable } from '@angular/core';
import { SubTaskFormData } from '@app/domain';
import { SubTaskRepository } from '@app/domain/repositories/sub-task.repository';
import {
  SubTaskCreateBodyModel,
  SubTaskDetailModel,
} from '@app/features/dashboard/domain/models/sub-task.model';
import { map, Observable } from 'rxjs';
import { SubTaskService } from '../api-clients';
import { SubTaskMapper } from '../mappers';

@Injectable()
export class SubTaskRepositoryImpl implements SubTaskRepository {
  private readonly _subTaskMapper = new SubTaskMapper();

  constructor(private readonly _subTaskService: SubTaskService) {}

  create(body: SubTaskCreateBodyModel): Observable<any> {
    const subTaskDTO = this._subTaskService.create(body);
    return subTaskDTO.pipe(
      map(dto => this._subTaskMapper.subTaskToDomain(dto))
    );
  }

  update(body: SubTaskCreateBodyModel): Observable<any> {
    const subTaskDTO = this._subTaskService.update(body);
    return subTaskDTO.pipe(
      map(dto => this._subTaskMapper.subTaskToDomain(dto))
    );
  }

  getDetail(
    subTaskId: number
  ): Observable<SubTaskDetailModel | SubTaskFormData> {
    const subTaskDTO = this._subTaskService.detail(subTaskId);
    return subTaskDTO.pipe(
      map(dto => dto as SubTaskDetailModel | SubTaskFormData)
    );
  }
}
